/**
 * Authored and generated text, rendered as it was WRITTEN — CCT-389.
 *
 * ⚠️ THE MODEL AND THE AUTHORS BOTH WRITE MARKDOWN, AND THE APP SHOWED IT RAW. A hint from a
 * character arrived as `**Côté fonctionnel** : ce qu'on doit livrer…` — the reader met the
 * asterisks, not the emphasis. Every surface that displays a story text is concerned: chats,
 * cards, user stories, scenes.
 *
 * ⚠️ AND THE EM DASH IS BANNED IN WHAT THE PLAYER READS. It is a product decision, not a taste:
 * the character is meant to speak, and a dash the reader has to interpret as a pause reads as
 * typography, not as speech. It becomes a comma and a space, WITH its surrounding spaces
 * absorbed — replacing the dash alone would leave " , ".
 *
 * ⚠️ NOTHING IS EVER DROPPED. An unmatched `**` stays literal: an author writing about a
 * multiplication or a glob pattern must see their own characters, not have them eaten by a rule
 * they did not ask for.
 */

/** One run of text and whether it is emphasised. */
export interface Segment {
  text: string;
  gras: boolean;
}

/**
 * The em dash, gone — including the spaces around it, so " a — b " gives " a, b ".
 *
 * The en dash is left alone: it lives between numbers ("2020-2024") where a comma would be wrong.
 */
export function sansCadratin(texte: string): string {
  return String(texte ?? '')
    .replace(/\s*—\s*/g, ', ')
    // A dash that opened the line has nothing to join: a leading ", " would be noise.
    .replace(/^,\s+/gm, '');
}

/**
 * Split a text into emphasised and plain runs.
 *
 * ⚠️ PAIRS ONLY. A lone `**` is content, not a broken tag — the reader keeps what was typed.
 */
export function segments(texte: string): Segment[] {
  const propre = sansCadratin(texte);
  const out: Segment[] = [];
  const motif = /\*\*([\s\S]+?)\*\*/g;
  let dernier = 0;
  let m: RegExpExecArray | null;
  while ((m = motif.exec(propre)) !== null) {
    if (m.index > dernier) out.push({ text: propre.slice(dernier, m.index), gras: false });
    out.push({ text: m[1], gras: true });
    dernier = m.index + m[0].length;
  }
  if (dernier < propre.length) out.push({ text: propre.slice(dernier), gras: false });
  return out.filter((s) => s.text !== '');
}
